
import { useVerificationMethods, VerificationMethod } from '@/hooks/useVerificationMethods';
import { VerificationForm } from './verification/VerificationForm';

interface MultiFactorAuthProps {
  methods: VerificationMethod[];
  onComplete: () => void;
  onCancel?: () => void;
  autoLogin?: boolean;
  requireAllVerified?: boolean;
}

export const MultiFactorAuth = ({ 
  methods, 
  onComplete,
  onCancel,
  autoLogin = true,
  requireAllVerified = false
}: MultiFactorAuthProps) => {
  const {
    error,
    setError,
    verifiedMethods,
    emailMethod,
    phoneMethod,
    phoneLoading,
    handleVerifyPhoneOtp,
    resendPhoneOtp,
    handleMethodVerified
  } = useVerificationMethods({
    methods,
    onComplete,
    autoLogin,
    requireAllVerified
  });
  
  return (
    <VerificationForm
      error={error}
      verifiedMethods={verifiedMethods}
      emailMethod={emailMethod}
      phoneMethod={phoneMethod}
      phoneLoading={phoneLoading}
      handleVerifyPhoneOtp={handleVerifyPhoneOtp}
      resendPhoneOtp={resendPhoneOtp}
      handleMethodVerified={handleMethodVerified}
      onCancel={onCancel}
    />
  );
};

export { type VerificationMethod };
